// Components
import MotivatorsPageLayer from "@Motivators/layouts/MotivatorsPageLayer";
import MotivatorsWrapper from "@Motivators/layouts/MotivatorsWrapper";

// Icons
import SB from "@/assets/icons/header/motivators/SB.svg";

const SpiffAwardsView = MotivatorsPageLayer({
	WrappedComponent: MotivatorsWrapper,
	headerTitle: "Sales Spiff Awards",
	headerIcon: SB,
	motivatorType: "spiffAwards",
});

export default SpiffAwardsView;
